import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHUnidadIns = async (credentials, data) => {
    const body = {
        service: "RNHUnidadIns",
        params: {
            rnhUnidadCod: data?.cod || null,
            rnhUnidadNombre: data?.name || null,
            rnhUnidadDescripcion: data?.desc || null,
            rnhDepartamentoId: data?.departamentoId || null,
            rnhDivisionId: data?.divisionId || null,
            // Los dos permisos de la reparticion. "Y"/"N", como el resto de las
            // banderas del modulo. Con `|| null` porque las dos son strings truthy: si
            // el modal los manda viaja el valor, y si todavia no los manda viaja null,
            // que para estos servicios es "no informado".
            rnhUnidadAdmiteRotativos: data?.admiteRotativos || null,
            rnhUnidadAdmiteGuardias: data?.admiteGuardias || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
